import { RowsRange } from '../../../feature/export/Utils.js';
import Combo from '../../../../Core/widget/Combo.js';

export default class ExportRowsCombo extends Combo {

    //region Config

    static $name = 'ExportRowsCombo';

    // Factoryable type name
    static type = 'exportrowscombo';

    static configurable = {
        editable : false,

        localizeDisplayFields : true
    };

    //endregion

    buildItems() {
        return [
            { id : RowsRange.all, text : 'L{all}' },
            { id : RowsRange.visible, text : 'L{visible}' }
        ];
    }
}

// Register this widget type with its Factory
ExportRowsCombo.initClass();
